class ComparisonChart extends HTMLElement {
  constructor() {
    super();
    this.row_titles = this.querySelectorAll(
      ".comparison-chart-row.comparison-chart-row-title"
    );


    this.resizeRowCells();

    window.addEventListener(
      "resize",
      debounce((event) => {
        this.resizeRowCells();
      }, 100)
    );
  }

  resizeRowCells() {
    this.row_titles.forEach((row_title) => {
      let row_id = row_title.dataset.rowId;
      let row_height = row_title.offsetHeight;

      let row_cells = this.querySelectorAll(
        ".comparison-chart-row[data-row-id=" +
          row_id +
          "]:not(.comparison-chart-row-title)"
      );
      row_cells.forEach((cell) => {
        cell.style.height = row_height + "px";
        cell.style.display = "flex";
      });
    });
  }
}
customElements.define("comparison-chart", ComparisonChart);
